module.exports = __webpack_public_path__ + "static/img/userlogo.8b4b0dff.png";